import type {SMSChatbotAction} from 'src/action-creators/sms-chatbot';
import type {SMSChatbotState} from 'src/types/sms-chatbot';
import {getDefaultNodeScheduleState} from 'src/utils/node-schedule';

import {
  RECEIVE_SMS_CHATBOT_INFO,
  UPDATE_SMS_CHATBOT_INFO,
  UPDATE_NODE_SCHEDULE,
  RESET,
} from 'src/action-creators/sms-chatbot';


const initialState = {
  flow_id: null,
  to_number: null,
  ...getDefaultNodeScheduleState({
    blackout_action: 'SEND_BEFORE',
  }),
} as const;

export default (
  state: SMSChatbotState = initialState,
  action: SMSChatbotAction,
): SMSChatbotState => {
  switch (action.type) {
    case UPDATE_SMS_CHATBOT_INFO:
      const updatePayload = action.payload;
      return {
        ...state,
        ...updatePayload,
      };
    case RECEIVE_SMS_CHATBOT_INFO:
      return {
        ...state,
        ...action.payload,
      };
    case UPDATE_NODE_SCHEDULE:
      return {
        ...state,
        ...action.payload,
      };
    case RESET:
      return {...initialState};
  }
  return state;
};
